module.exports = __webpack_public_path__ + "static/media/sm.9591e46a.svg";